import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Box, LinearProgress } from '@mui/material'
import { BaseFeedbackConIcona, useRichiestaServer } from '@lucan/base-ui'
import { OPERAZIONI } from 'configuration/ConfigurazioneApi'
import { CHIAVI_SESSIONE } from 'configuration/ConfigurazioneSessione'
import { useSessione } from 'context/SessioneProvider'
import { useAppContext } from 'GlobalContext'

export default function CheckSsoCIE() {
  const { intermediario, uuidAssertion } = useParams()

  const { uri } = useAppContext()

  const [messaggio, setMessaggio] = useState()

  const { rimuoviDaSessione, [CHIAVI_SESSIONE.CHIAVE_UUID_ROOM]: uuidRoom } = useSessione()

  const {
    ScatolaMessaggi,
    inviaOperazione,
    inAttesaDelServer
  } = useRichiestaServer()

  useEffect(() => {
    async function checkSso() {
      const { ok, data } = await inviaOperazione(OPERAZIONI.CIE_CHECKSSO, null, {}, {
        urlParams: { intermediario },
        params: { uudi_room: uuidRoom, assertion_uuid: uuidAssertion },
        headers: { uri },
      })

      if (ok) {
        const { esito, url } = data
        if (esito) {
          rimuoviDaSessione(CHIAVI_SESSIONE.CHIAVE_UUID_ROOM)
          window.location.href = url
        } else {
          setMessaggio('Errore nella chiamata')
        }
      }
    }
    checkSso()
  }, [uuidRoom, uuidAssertion])

  return (
    <Box sx={{ p: 4 }}>
      {ScatolaMessaggi}
      {messaggio && <BaseFeedbackConIcona.Errore messaggio={messaggio} />}
      {inAttesaDelServer && <LinearProgress />}
    </Box>
  )
}